/**
 * ADR-012 — redirect legacy duplicate `donate/*` mounts to canonical `/:tenantCode/donate/*`.
 */
import { Navigate, useLocation } from 'react-router-dom';
import { stripOidcLandFromSearch } from '../../shared/session/returnTarget.js';
import { useTenantCode } from '../../shared/tenant/TenantProvider.js';

export function DonateLegacyPathRedirect(): JSX.Element {
  const tenantCode = useTenantCode();
  const location = useLocation();
  const prefix = `/${encodeURIComponent(tenantCode)}`;
  const donateMatch = location.pathname.match(/\/donate(\/.*)?$/);
  const suffix = donateMatch?.[1] ?? '';
  // Strip oidcLand: RR search can lag after replaceState force-strip.
  const search = stripOidcLandFromSearch(location.search);
  return <Navigate to={`${prefix}/donate${suffix}${search}`} replace />;
}
